import { Link } from 'react-router'
import { ArrowRight } from 'lucide-react'
import { useSettings } from '@/lib/queries'

const BAR =
  'group flex items-center justify-center gap-3 bg-blood px-5 py-2.5 text-center text-bone'

/**
 * Announcement strip, driven entirely by the CMS. Rendered inside the fixed
 * header stack so it never collides with the full-bleed hero underneath.
 *
 * While the settings request is in flight the bar's height is reserved rather
 * than left at zero. Letting it pop in afterwards pushed the whole page down
 * and cost about 0.1 of cumulative layout shift — the single largest source on
 * the home page.
 */
export function AnnouncementBar() {
  const { data: settings, isPending } = useSettings()

  if (isPending) {
    return (
      <div
        className="bg-blood/25 h-[2.6875rem]"
        aria-hidden
        // Same height as the real bar (py-2.5 + one line of 13px condensed
        // text). Keep the two in step if the padding changes.
      />
    )
  }

  if (!settings?.announcement_active || !settings.announcement_text) return null

  const body = (
    <>
      <span className="animate-pulse-live bg-bone size-1.5 shrink-0 rounded-full" aria-hidden />
      <span className="condensed text-[0.8125rem] font-semibold tracking-[0.12em]">
        {settings.announcement_text}
      </span>
      {settings.announcement_url ? (
        <ArrowRight
          className="size-4 shrink-0 transition-transform group-hover:translate-x-1"
          aria-hidden
        />
      ) : null}
    </>
  )

  return settings.announcement_url ? (
    <Link to={settings.announcement_url} className={BAR}>
      {body}
    </Link>
  ) : (
    <div className={BAR}>{body}</div>
  )
}
